export default "__VITE_ASSET__9edcc6da__"